module.exports = __webpack_public_path__ + "img/4-2-4-3-0-preview-LogoKV-e.97b1451e.jpg";